(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-custom-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".collection-header-section");
    if (!section) return;
  
    const button = section.querySelector(".collection-header-section__button");
    const description = section.querySelector(".collection-header-section__description");
  
    if (!button || !description) return;
  
    button.addEventListener("click", function () {
      const isExpanded = description.classList.toggle("expanded");
      description.style.maxHeight = isExpanded ? "none" : "8em";
  
      button.textContent = isExpanded
        ? button.getAttribute("data-read-less")
        : button.getAttribute("data-read-more");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
